<accredible-two-columns-layout
  *transloco="let t; read: 'acs-fa-locked-account'"
  [singleColumn]="true"
  backgroundImage="'/assets/images/two-columns-layout-component/layout-purple.png'">
  <accredible-top-border-card>
    <img src="/assets/images/accredible-new-logo.svg" alt="" />

    <div class="title">
      {{ t('title') }}
    </div>

    <img src="/assets/images/hints-and-guidance/locked.svg" alt="" />

    <div class="description">
      {{ t('description', { email: lockedUserEmail }) }}
    </div>

    <div class="actions-container">
      <div class="resend-label">
        {{ t('resend_label') }}
      </div>

      <button
        accredible-button-outline
        data-cy="btn-resend"
        (click)="resendRecoveryEmail()"
        color="natural">
        {{ t('resend') }}
      </button>

      <a
        accredible-button-flat
        icon="chevron-left"
        iconPosition="left"
        [routerLink]="'/login'"
        data-cy="link-back-to-login">
        {{ t('back') }}
      </a>
    </div>
  </accredible-top-border-card>
</accredible-two-columns-layout>
